export const PERMISSION_STRINGS = {
    PERMISSIONS: "Permissions",
    SEARCH_PAGE: "Search Page",
    SEARCH_ROLES: "Search Roles",
    SAVE_PERMISSIONS: "Save Permissions",
    MODULE: "Module",
    PAGE: "Page"
};

export const PERMISSION_KEYS = {
    ROLE_NAME: "rolename"
}

export const PERMISSION_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "rolename", isSortable: true, label: "Role" },
];

export const PERMISSION_TABLE_COLUMN_KEYS = {
    ACTIONS: "actions",
    ROLE_NAME: "rolename",
};

export const PAGE_PERMISSION_TABLE_COLUMNS = [
    { id: "name", isSortable: false, label: "Name" },
    { id: "type", isSortable: false, label: "Type" },
    { id: "access", isSortable: false, label: "Access" },
];

export const PAGE_PERMISSION_TABLE_COLUMN_KEYS = {
    NAME: "name",
    TYPE: "type",
    ACCESS: "access",
};

export const PERMISSION_MESSAGES = {
    NO_ROLES: "No roles to display",
    NO_PAGES: "No pages found for this role.",
    PERMISSIONS_UPDATED: "Permissions updated successfully!",
    NO_CHANGES: "No changes to save."
};

export const PERMISSION_ERRORS = {
    FETCH_MENUS_ERROR: "Error fetching menus.",
    PERMISSIONS_UPDATE_FAILED: "Failed to update permissions.",
};
